jQuery(() => {
	let typingTimer = null;
	const $reportLocationInput = $('#reportLocation');
	const $reportSuggestions = $reportLocationInput.siblings('.suggestions');

	function reportAddressLookup(address) {
		const params = {
			format: 'json',
			q: address,
			countrycodes: 'hu',
			addressdetails: 1,
			'accept-language': 'hu;q=1',
			limit: 50,
		};
		$.get('https://nominatim.openstreetmap.org/', params, response => {
			$reportSuggestions.empty();
			if (response.length) {
				response
					.filter(result => result.addresstype === 'road' || result.addresstype === 'building')
					.filter(result => result.address && result.address.city && result.address.city.toLowerCase().includes('veszprém') && result.address.road)
					.map(result => {
						result.displayName = result.address.city + ', ' + result.address.road + (result.address.amenity ? (', ' + result.address.amenity) : '');
						return result;
					})
					.filter((v, i, arr) => { return i === arr.findIndex(v2 => v2.displayName === v.displayName); })
					.forEach(result => {
						$reportSuggestions.append(`<li><a href="#" data-lat="${result.lat}" data-lon="${result.lon}">${result.displayName}</a></li>`);
					});
			}
		});
	}

	$reportLocationInput.on('input', function () {
		if (typingTimer) {
			clearTimeout(typingTimer);
		}
		typingTimer = setTimeout(() => {
			reportAddressLookup(this.value);
		}, 300);
	});
	$reportSuggestions.on('click', 'a', function (e) {
		e.preventDefault();
		const selectedLat = $(this).attr('data-lat');
		const selectedLon = $(this).attr('data-lon');
		if (selectedLon > 17 && selectedLon < 19 && selectedLat > 46 && selectedLat < 48) {
			const selectedCoord = ol.proj.fromLonLat([selectedLon, selectedLat]);
			window.veszpremMap.getLayers().item(1).getSource().getFeatures()[0].setGeometry(new ol.geom.Point(selectedCoord));
			window.veszpremMap.getView().setCenter(selectedCoord);
			window.veszpremMap.getView().setZoom(17);
			const latInput = document.getElementById('reportLocationLat')
			const lngInput = document.getElementById('reportLocationLng');
			if (latInput && lngInput) {
				latInput.value = selectedLat;
				lngInput.value = selectedLon;
			}
			$reportLocationInput.val($(this).text());
		}
		$(this).closest('.suggestions').empty();
	});

	if (typeof Dropzone === 'function' && $('#dropzone').length) {
		let dropzone = new Dropzone("#dropzone", {
			url: '/wp-json/veszprem/v1/report-upload-image',
			dictDefaultMessage: '<span class="material-icons-outlined md-36">add_photo_alternate</span><span>Képek hozzáadása saját eszközről</span>',
			autoProcessQueue: false,
			acceptedFiles: 'image/*',
			addRemoveLinks: true,
			success: (file, response) => {
				file.id = response.id;
			},
			queuecomplete: function () {
				uploadForm();
			},
			processing: function () {
				this.options.autoProcessQueue = true;
			},
			totaluploadprogress: function () {
			},
			error: function () {
			},
			errormultiple: function () {
			}
		});
		const $form = $('#reportForm').submit(function (e) {
			e.preventDefault();
			if (runFormValidations()) {
				grecaptcha.ready(function () {
					const recaptchaSiteKey = document.getElementById('recaptchaSiteKey').value;
					grecaptcha.execute(recaptchaSiteKey, {action: 'create_report'}).then(function (token) {
						document.getElementById('recaptchaResponse').value = token;
						$form.find('button[type="submit"]').prop('disabled', true).addClass('loading');
						if (dropzone.files.filter(file => file.status === Dropzone.QUEUED).length) {
							dropzone.processQueue();
						} else {
							uploadForm();
						}
					});
				});
			}
		});
		$form.find('input[required], textarea[required], select[required]').removeAttr('required');
		$form.find('input, textarea, select').on('change input', function () {
			if ($(this).hasClass('is-invalid')) {
				$(this).removeClass('is-invalid');
			}
		});

		function uploadForm() {
			$form.find('button[type="submit"]').prop('disabled', true).addClass('loading');
			const $fileWrapper = $form.find('.file-ids').empty();
			dropzone.files.forEach(file => {
				if (file.status === Dropzone.SUCCESS) {
					$fileWrapper.append(`<input type="hidden" name="files[]" value="${file.id}">`);
				}
			});
			$.post(
				'/wp-json/veszprem/v1/report-submit',
				$form.serialize(),
				response => {
					$form.find('button[type="submit"]').prop('disabled', false).removeClass('loading');
					if (response && response.redirect_url) {
						window.location.href = response.redirect_url;
					}
				},
				'json'
			).fail(() => {
				alert('Az adatok beküldése közben hiba történt, próbálja újra később!');
				$form.find('button[type="submit"]').prop('disabled', false).removeClass('loading');
			});
		}

		function runFormValidations() {
			const validations = {
				reportPersonalLastName: i => !!i.value,
				reportPersonalFirstName: i => !!i.value,
				reportPersonalEmail: i => !!i.value && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(i.value),
				reportPersonalPhone: i => !!i.value,
				reportProblemType: i => !!i.value && i.value !== '0',
				reportProblemDate: i => !!i.value,
				reportProblemTitle: i => !!i.value,
				reportProblemDescription: i => !!i.value,
				reportAccept1: i => i.checked,
				reportAccept2: i => i.checked,
			};
			$form.find('.is-invalid').removeClass('is-invalid');
			let errorFound = false;
			for (const [id, validator] of Object.entries(validations)) {
				const elem = document.getElementById(id);
				if (!validator.call(null, elem)) {
					errorFound = true;
					$(elem).addClass('is-invalid');
				}
			}
			if (errorFound) {
				$form.find('.is-invalid').first().focus();
			}
			return !errorFound;
		}
	}
});
